<agpr-take-over-panel
    #takeOverPanel
    id="adHocReportPanel"
    class="agpr-adHocReportPanel"
    header="AutomationAgents.adHoc.report.title"
    headerIcon="fa-kit-duotone fa-agpr-ai-generic"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="960"
    [maxPanelWidth]="1400"
    [noScroll]="true"
    [noPadding]="true"
    [fullHeight]="true"
    footerContext="AutomationAgents.adHoc.report.title"
    (visibleChange)="onVisibleChange($event)"
>
    <ng-template #noScrollContent>
        <div class="agpr-adHocReportPanel-body">
            <div class="agpr-adHocReportPanel-main">
                <h3 class="agpr-adHocReportPanel-heading">
                    {{ 'AutomationAgents.adHoc.report.curatedMentions' | localize }}
                </h3>

                <!-- The shared feed, on this panel's own search service -->
                <agpr-mention-search-result
                    [dateFilterOptions]="dateFilterOptions"
                    [dateFilterOptionsFromRoute]="false"
                    [highlightSavedMentions]="false"
                ></agpr-mention-search-result>
            </div>

            <aside class="agpr-adHocReportPanel-sidebar">
                <agpr-right-sidebar
                    #rhpTabs
                    [loading]="isLoading"
                    (selectedTabIndexChange)="tabChange($event)"
                    (headerIconClicked)="openMentionTakeOver()"
                    [ngClass]="{
                        'agpr-rightSidebar--stickyTitle': rhpTabs.selectedTab?.id === 'adHocReportMention',
                        'agpr-rightSidebar--noMention': !focusedMention
                    }"
                >
                    <agpr-tab
                        [id]="'adHocReportMention'"
                        icon="fa-file"
                        tooltip="Monitoring.results.rhp.mention"
                        [headerIcon]="'fa-solid fa-duotone fa-circle-chevron-left'"
                        headerIconTooltip="Mention.results.rhp.mentionContent.headerIcon"
                    >
                        @if (mentions?.length) {
                            <agpr-mention-information
                                [id]="'adHocReport_mentionInformation'"
                                [showInsights]="focusedMention && !!focusedMention.mentionId"
                            ></agpr-mention-information>
                        } @else {
                            <agpr-panel header="Mention.details.mention">
                                <agpr-message
                                    [severity]="messageSeverity.noContent"
                                    [useWhiteBg]="true"
                                >
                                    {{ 'Monitoring.result.noMentionsAvailable' | localize }}
                                </agpr-message>
                            </agpr-panel>
                        }
                    </agpr-tab>

                    <agpr-mention-insights-explorer-tab
                        *ngIf="mieEnabled"
                        [id]="'adHocReportMentionInsightsExplorerTab'"
                        icon="fa-kit-duotone fa-agpr-insights"
                        tooltip="Monitoring.results.rhp.mentionInsightExplorer"
                    ></agpr-mention-insights-explorer-tab>

                    <agpr-entity-details-tab
                        [id]="'adHocReportRhpTab.contactProfile'"
                        icon="fa-user"
                        tooltip="Discover.targeting.rhp.tabs.profileMeta"
                        [entityType]="entityTypes.CONTACT"
                        [syncOutletTabInfo]="false"
                        [noContactMessage]="
                            focusedMention?.author?.name
                                ? 'Monitor.entityProfile.noAdditionalInfo'
                                : 'Monitor.entityProfile.noContact'
                        "
                        (loading)="isLoading = $event"
                    ></agpr-entity-details-tab>

                    <agpr-entity-details-tab
                        [id]="'adHocReportRhpTab.outletProfile'"
                        icon="fa-kit-duotone fa-agpr-outlet"
                        tooltip="Discover.targeting.rhp.tabs.outletProfileMeta"
                        [entityType]="entityTypes.OUTLET"
                        [noOutletMessage]="
                            focusedMention?.publication?.name
                                ? 'Monitor.entityProfile.noAdditionalInfo'
                                : 'Monitor.entityProfile.noOutlet'
                        "
                        (loading)="isLoading = $event"
                    ></agpr-entity-details-tab>

                    <!-- Where the folder results carry Folder Details, this carries the run's report -->
                    <agpr-tab
                        [id]="'adHocReportSummary'"
                        icon=" fa-file-lines"
                        [showSpacer]="true"
                        tooltip="AutomationAgents.adHoc.report.heading"
                    >
                        <agpr-ad-hoc-curation-report
                            [agent]="agent"
                            [run]="run"
                        ></agpr-ad-hoc-curation-report>
                    </agpr-tab>

                    <agpr-tab
                        [id]="'adHocReportCharts'"
                        icon=" fa-pie-chart"
                        tooltip="Monitoring.results.rhp.charts"
                    >
                        <agpr-monitoring-result-charts></agpr-monitoring-result-charts>
                    </agpr-tab>

                    <agpr-entity-list-tab
                        [id]="'adHocReportRhpTab.contactList'"
                        [entityMode]="entityTypes.CONTACT"
                        [hidden]="!hasDiscoverPermission"
                        [tooltip]="'Monitoring.results.rhp.contactList.tooltip' | localize"
                        (showRhpTakeOver)="openEntityTakeover($event)"
                    ></agpr-entity-list-tab>

                    <agpr-entity-list-tab
                        [id]="'adHocReportRhpTab.outletList'"
                        [entityMode]="entityTypes.OUTLET"
                        [hidden]="!hasDiscoverPermission"
                        [tooltip]="'Monitoring.results.rhp.outletList.tooltip' | localize"
                        (showRhpTakeOver)="openEntityTakeover($event)"
                    ></agpr-entity-list-tab>
                </agpr-right-sidebar>
            </aside>
        </div>
    </ng-template>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            id="adHocReportPanel.close"
            label="Core.button.close"
            [style]="buttonTypes.secondary"
            (click)="close()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
